"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePagination = void 0;
var react_1 = require("react");
var react_scroll_1 = __importDefault(require("react-scroll"));
var objectUtilities_1 = require("../../../util/objectUtilities");
var Pagination_static_1 = require("./Pagination.static");
/**
 * usePagination hook
 *
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/molecules/Pagination/Pagination.logic.ts Source}
 */
function usePagination(_a) {
    var itemsPerPage = _a.itemsPerPage, items = _a.items, pageChangeScrollCorrection = _a.pageChangeScrollCorrection;
    var numberOfPages = Math.max(Math.ceil(items.length / itemsPerPage), 1);
    var containerRef = (0, react_1.useRef)(null);
    var paginationReducer = (0, react_1.useCallback)(function (state, action) {
        !action.skipScroll &&
            containerRef.current &&
            react_scroll_1.default.animateScroll.scrollTo(Math.max(containerRef.current.getBoundingClientRect().top + window.pageYOffset - (pageChangeScrollCorrection || 0), 0));
        var type = action.type;
        switch (type) {
            case Pagination_static_1.PaginationAction.GoToFirstPage:
                return 1;
            case Pagination_static_1.PaginationAction.GoToLastPage:
                return numberOfPages;
            case Pagination_static_1.PaginationAction.GoToNextPage:
                return state + 1;
            case Pagination_static_1.PaginationAction.GoToPreviousPage:
                return state - 1;
            case Pagination_static_1.PaginationAction.GoToSpecificPage:
                return action.payload;
            default:
                return (0, objectUtilities_1.exhaustivenessCheck)(type);
        }
    }, [numberOfPages, pageChangeScrollCorrection]);
    var _b = __read((0, react_1.useReducer)(paginationReducer, 1), 2), currentPage = _b[0], dispatchPagination = _b[1];
    (0, react_1.useEffect)(function () {
        if (currentPage > numberOfPages) {
            dispatchPagination({ type: Pagination_static_1.PaginationAction.GoToLastPage });
        }
    }, [currentPage, numberOfPages]);
    var renderFrom = (currentPage - 1) * itemsPerPage;
    var renderTo = Math.min((currentPage - 1) * itemsPerPage + itemsPerPage, items.length);
    var itemsOnCurrentPage = (0, react_1.useMemo)(function () { return items.slice(renderFrom, renderTo); }, [renderFrom, renderTo, items]);
    return {
        itemsOnCurrentPage: itemsOnCurrentPage,
        goToNextPage: function () { return dispatchPagination({ type: Pagination_static_1.PaginationAction.GoToNextPage }); },
        goToPreviousPage: function () { return dispatchPagination({ type: Pagination_static_1.PaginationAction.GoToPreviousPage }); },
        isOnFirstPage: currentPage === 1,
        isOnLastPage: currentPage === numberOfPages,
        itemsOnPageInfo: Pagination_static_1.localText.itemsOnPage(currentPage, numberOfPages),
        goToLastPage: function () { return dispatchPagination({ type: Pagination_static_1.PaginationAction.GoToLastPage }); },
        goToFirstPage: function () { return dispatchPagination({ type: Pagination_static_1.PaginationAction.GoToFirstPage }); },
        containerRef: containerRef,
        dispatchPagination: dispatchPagination,
    };
}
exports.usePagination = usePagination;
